import React from 'react'
import { createPortal } from 'react-dom'

export const usePortal = (): {
  Portal: (props: { children: React.ReactNode }) => React.ReactPortal | null
} => {
  const Portal = React.useMemo(() => {
    const PortalComponent = ({ children }: { children: React.ReactNode }) => {
      const [mounted, setMounted] = React.useState(false)

      React.useEffect(() => {
        // Prevent from portal being rendered on server, and doesn't break SSR hydration
        setMounted(true)
      }, [])

      return mounted ? createPortal(children, document.body) : null
    }

    return PortalComponent
  }, [])

  return { Portal }
}
